<template>
  <div>
    <canvas :id="chartId"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default {
  name: 'LineChart',
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    chartId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      ctx: null,
    };
  },
  mounted() {
    this.ctx = document.getElementById(this.chartId);
    this.chart = new Chart(this.ctx, {
      type: 'line',
      data: this.data,
      options: this.options
    })

  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.chart = new Chart(this.ctx, {
          type: 'line',
          data: this.data,
          options: this.options
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
canvas {
  max-width: 100%;
  min-height: 220px;
  max-height: 400px;
}
</style>
